import { useLocation, Navigate } from 'react-router-dom';
import { useAdminAuth } from './hooks/useAdminAuth';
import AdminLogin from './AdminLogin';
import AdminLayout from './AdminLayout';

const pathPermMap: Record<string, string> = {
  '/admin': 'dashboard',
  '/admin/customers': 'customers',
  '/admin/articles': 'articles',
  '/admin/cases': 'cases',
  '/admin/faqs': 'faqs',
  '/admin/settings': 'settings',
};

const permOrder = ['dashboard', 'customers', 'articles', 'cases', 'faqs', 'settings'];

function getRequiredPermission(pathname: string): string | null {
  if (pathPermMap[pathname]) return pathPermMap[pathname];
  for (const [path, perm] of Object.entries(pathPermMap)) {
    if (path !== '/admin' && pathname.startsWith(path + '/')) return perm;
  }
  return null;
}

export default function AdminEntry() {
  const { session, loading, login, logout } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#f8f5f0] flex items-center justify-center">
        <div className="text-center text-gray-400">
          <i className="ri-loader-4-line text-3xl animate-spin block mb-2"></i>
          <span className="text-sm">验证身份中...</span>
        </div>
      </div>
    );
  }

  if (!session) {
    return <AdminLogin onLogin={login} />;
  }

  // Route permission guard: redirect to first allowed module if no permission
  const requiredPerm = getRequiredPermission(location.pathname);
  if (requiredPerm && !session.permissions.includes(requiredPerm)) {
    const firstAllowed = permOrder.find((p) => session.permissions.includes(p));
    const fallbackPath = firstAllowed ? (firstAllowed === 'dashboard' ? '/admin' : `/admin/${firstAllowed}`) : '/admin';
    return <Navigate to={fallbackPath} replace />;
  }

  return <AdminLayout session={session} onLogout={logout} />;
}